module.exports = __webpack_public_path__ + "static/media/facebook.b3b9f8a9.svg";